import { render } from "./NftConstructorTitle.vue?vue&type=template&id=21f2362d"
import script from "./NftConstructorTitle.vue?vue&type=script&lang=js"
export * from "./NftConstructorTitle.vue?vue&type=script&lang=js"

import "./NftConstructorTitle.vue?vue&type=style&index=0&id=21f2362d&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__